import Results from 'components/hits/results'
import Card from 'components/card/card'
import { connectHits, Pagination } from 'react-instantsearch-dom'

const Hits = ({ hits, insights, hideRating }) => {
    return (
        <div className="ais-Hits-list">
            {hits && hits.map(hit => <Card key={hit.code} insights={insights} hit={hit} hideRating={hideRating} />)}
        </div>
    )
}

const CustomHits = connectHits(Hits)

export default function ResultsComponent({ hideRating }) {
    return (
        <>
        <Results>
            <CustomHits hideRating={hideRating} />
           
        </Results>
         <Pagination padding={2} />
         </>
    )
}
